import { createContext } from 'react';

type AccordionContextTypes = {
  onHeaderKeyDown?: (event: any) => void;
  onToggle: (isExpand: boolean) => void;
  id: string;
};

export const AccordionContext = createContext<AccordionContextTypes>({
  id: '',
  onToggle: (isExpand: boolean) => {},
});

type SelectableContextType = {
  index: number;
  onSelect?: (event: any) => void;
};

export const SelectableContext = createContext<SelectableContextType>({
  index: 0,
});
